module.exports = __webpack_public_path__ + "img/wi-fi.1b8f7df1.svg";